import Base from '../Base';

export default class SettingSetting extends Base {
    static url = '/api/setting/setting';
}
